import styled, { keyframes } from 'styled-components';

interface FilterProps {
  isOpen: boolean;
}

const fadeIn = keyframes`
  0% {
    transform: scale(0.5);
    transform-origin: 0% 0%;
    -webkit-transform: scale(0.5);
    -webkit-transform-origin: 0% 0%;
  }
  100% {
    transform: scale(1);
    transform-origin: 0% 0%;
    -webkit-transform: scale(1);
    -webkit-transform-origin: 0% 0%;
  }

`;

const fadeOut = keyframes`
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
    transform-origin: 0% 0%;
    -webkit-transform-origin: 0% 0%;
  }
  100% {
    transform: scale(0.5);
    transform-origin: 0% 0%;
    -webkit-transform: scale(0.5);
    -webkit-transform-origin: 0% 0%;
  }
`;

export const Container = styled.div<FilterProps>`
  grid-area: filter;
  display: ${props => props.isOpen ? 'flex' : 'none'};
  animation: ${({ isOpen }) => !isOpen ? fadeOut : fadeIn} .1s linear;
`;

export const Overlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 22px;
  
  max-width: 531px;
  background: #FFFFFF;
  
  border-radius: 3px;
  
  height: fit-content;
  box-shadow: 13px 12px 26px 0px rgba(0, 0, 0, 0.09);

  @media(max-width: 820px){
    top: 15%;
    right: 2%;
    z-index: 9;
    width: 80%;
    margin: 0 auto;
    position: relative;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  
  margin: 0 auto;
  flex-direction: column;

`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  
  margin-bottom: 1rem;
  background: 
    linear-gradient(90deg, rgba(177, 180, 182, 0.00) 
      0.52%, #B1B4B6 53.13%, rgba(177, 180, 182, 0.00) 100%);
`;

